import { z } from 'zod';
import { nonEmptyTrimmed, uuidSchema } from './common.js';
import { SIZE_CLASSES } from '../constants.js';
export const createServiceTypeSchema = z.object({
    name: nonEmptyTrimmed(80),
    sort: z.number().int().optional(),
});
export const updateServiceTypeSchema = z.object({
    name: nonEmptyTrimmed(80).optional(),
    isActive: z.boolean().optional(),
    sort: z.number().int().optional(),
});
export const createCoverageSchema = z.object({
    name: nonEmptyTrimmed(80),
    sqft: z.number().min(0).nullable().optional(),
    laborHours: z.number().min(0),
    sort: z.number().int().optional(),
});
export const updateCoverageSchema = createCoverageSchema.partial().extend({ isActive: z.boolean().optional() });
export const createMaterialSchema = z.object({
    brand: nonEmptyTrimmed(80),
    series: z.string().trim().max(80).optional(),
    costPerSqftCents: z.number().int().min(0),
    priceMultiplier: z.number().min(0.5).max(5),
});
export const updateMaterialSchema = createMaterialSchema.partial().extend({ isActive: z.boolean().optional() });
export const coverageSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    sqft: z.number().nullable(),
    laborHours: z.number(),
    isActive: z.boolean(),
    sort: z.number(),
});
export const materialSchema = z.object({
    id: uuidSchema,
    brand: z.string(),
    series: z.string(),
    costPerSqftCents: z.number(),
    priceMultiplier: z.number(),
    isActive: z.boolean(),
});
export const serviceTypeSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    isActive: z.boolean(),
    sort: z.number(),
    coverages: z.array(coverageSchema),
    materials: z.array(materialSchema),
});
export const pricingRulesSchema = z.object({
    currency: z.string(),
    laborRateCents: z.number(),
    roundingCents: z.number(),
    taxRateBps: z.number(),
    depositPct: z.number(),
    quoteValidityDays: z.number(),
    termsText: z.string(),
});
export const updatePricingRulesSchema = pricingRulesSchema.partial();
// Scales a coverage's base sqft/laborHours (coverageSchema above) by vehicle
// size class when a PPF/tint/ceramic quote line is priced - see
// server/src/modules/quotes/lines.ts. 10000bp = 1.00x (no change).
export const coverageSizeMultiplierSchema = z.object({
    sizeClass: z.enum(SIZE_CLASSES),
    sqftMultiplierBp: z.number().int().positive(),
    laborMultiplierBp: z.number().int().positive(),
});
export const updateSizeMultiplierSchema = z.object({
    sqftMultiplierBp: z.number().int().positive().optional(),
    laborMultiplierBp: z.number().int().positive().optional(),
});
export const catalogResponseSchema = z.object({
    serviceTypes: z.array(serviceTypeSchema),
    pricingRules: pricingRulesSchema,
    sizeMultipliers: z.array(coverageSizeMultiplierSchema),
});
export function classifyServiceKind(serviceName) {
    const name = serviceName.toLowerCase();
    if (/print|graphic|印刷/i.test(name))
        return 'print';
    if (name.includes('tint'))
        return 'tint';
    if (name.includes('ppf') || name.includes('paint protection'))
        return 'ppf';
    if (name.includes('ceramic'))
        return 'ceramic';
    return 'wrap';
}
export const VLT_OPTIONS = [5, 20, 35, 50, 70];
export const PPF_FINISH_OPTIONS = ['Gloss', 'Satin', 'Matte'];
export const WRAP_FINISH_OPTIONS = ['Gloss', 'Matte', 'Satin', 'Metallic', 'Chrome', 'Color-shift'];
//# sourceMappingURL=catalog.js.map